<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12" :class="`tabs ${providerType ? 'full-border hidden-tabs' : false}`">
            <h2 class="mt-2">
                {{ pageTitle }}
            </h2>
            <v-tabs v-model="tab" show-arrows>
                <v-tab v-for="(item, index) in tabsItems" :key="index">
                    <div class="tab">{{ item.name }}</div>
                </v-tab>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="item in tabsItems" :key="item.key">
                        <v-form :disabled="!canStore">
                            <component :is="item.component"></component>
                            <laboratory-c-c-actions
                                v-if="item.hasActions"
                                @reloadLabOrCC="loadLabOrCC"
                            ></laboratory-c-c-actions>
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tab: 0,
            tabsItems: [
                {
                    key: 0,
                    name: t('blood-providers::tabs.new_laboratory'),
                    component: 'new-laboratory-form',
                    hasActions: true,
                },
                {
                    key: 1,
                    name: t('blood-providers::tabs.new_collection_centre'),
                    component: 'new-collection-centre',
                    hasActions: true,
                },
            ],
            radioGroup: [
                { text: 'New Laboratory', value: 'laboratories' },
                { text: 'New Collection Centre', value: 'collection-centres' },
            ],
            providers: { cc: 'collection-centres', lab: 'laboratories' },
            providersState: { cc: 'collection_centre', lab: 'laboratory' },
            providerType: null,
        };
    },
    computed: {
        canStore() {
            return (
                (this.currentForm.id && can('api.v1.laboratories.update')) ||
                (!this.currentForm.id &&
                    can('api.v1.laboratories.store') &&
                    this.currentForm.id &&
                    can('api.v1.collection-centres.update')) ||
                (!this.currentForm.id && can('api.v1.collection-centres.store'))
            );
        },
        currentForm: {
            get() {
                return _.get(this.$store.state.laboratories, 'currentForm');
            },
            set(value) {
                this.$store.dispatch('laboratories/changeForm', value);
            },
        },
        pageTitle() {
            if (!this.canStore) {
                return 'Preview Laboratory or CC';
            }

            return this.id
                ? t('blood-providers::page.title.edit_laboratories_cc')
                : t('blood-providers::page.title.new_laboratories_cc');
        },
    },
    watch: {
        tab(tab) {
            return (this.currentForm = tab === 0 ? 'laboratories' : 'collection-centres');
        },
    },
    created() {
        this.currentForm = 'laboratories';
        // this.$store.dispatch('laboratories/loadNPTDevicesOptions');
        this.loadLabOrCC();
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('providers.index'));
        },
        loadLabOrCC() {
            const urlParams = new URLSearchParams(window.location.search);
            const providerType = urlParams.get('type');

            this.tab = providerType === 'cc' ? 1 : 0;

            if (providerType !== 'cc') {
                this.$store.dispatch('laboratories/loadNPTDevicesOptions', { id: this.id });
                // this.$store.dispatch('laboratories/loadASTMDevicesOptions', { id: this.id });
            }

            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }

            if (providerType) {
                this.setProviderType(providerType);
            }

            axios
                .get(
                    route('api.v1.providers.show', {
                        blood_result_provider: this.id,
                        fields: '*,type',
                    })
                )
                .then((response) => {
                    const responseData = response.data.data;

                    if (!this.providerType) {
                        this.setProviderType(responseData.type);
                    }

                    const data = { data: responseData, formToSet: this.providersState[this.providerType] };

                    this.$store.dispatch('laboratories/loadDataForForm', data);
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setProviderType(providerType) {
            this.providerType = providerType;
            this.$store.dispatch('laboratories/changeForm', this.providers[this.providerType]);
        },
    },
};
</script>

<style></style>
